import { Box, Text, customStyled } from '@mafc/trolly';

export const AddressLabel = customStyled(Text.Caption)(({ theme }) => ({
  fontWeight: theme.fontWeights[5],
  fontSize: theme.fontSizes[2],
  color: theme.colors.black,
  textTransform: 'capitalize',
}));

export const DeliverTo = customStyled(Text.Caption)(({ theme }) => ({
  margin: '0 4px 0 0',
  fontSize: theme.fontSizes[2],
  fontWeight: theme.fontWeights[8],
  color: theme.colors.black,
}));

export const IconWapper = customStyled(Box)(() => ({
  height: '20px',
  width: '17%',
  maxWidth: '20px',
}));

export const SingleAddress = customStyled(Box)(({ theme }) => ({
  color: theme.colors.black,
}));
